/* =========================================================================
   CAIXA DE SEGURANÇA DOS RÓTULOS DA BARRA DE RECOMPENSAS

   A posição de cada bolinha é proporcional ao valor (o Liquid calcula), e é
   isso que a barra precisa comunicar. Mas prêmios próximos — R$399 e R$499
   numa régua que termina em 499 — ficam a 20% de distância, e nessa largura
   "R$399,00 / R$499,00" e "Frete grátis / Bag Blumi" se sobrepõem.

   Aqui as caixas são MEDIDAS e recuam até caber: primeiro nenhuma passa da
   borda direita do trilho, depois as vizinhas se afastam entre si, e por fim
   nenhuma escapa pela esquerda. Com três ou mais, o recuo se propaga em cadeia.

   O recuo da borda direita é o que deixa a última bolinha centralizada sobre o
   próprio texto em vez de colada na ponta dele — e, como ela para antes do fim,
   a barra continua depois dela.

   POR QUE ISTO NÃO DÁ PARA FAZER NO LIQUID
   A colisão depende da largura do texto em pixels, que muda com a fonte, o
   tamanho da tela e o que a pessoa escreveu na configuração do rótulo. Uma
   folga fixa em porcentagem erraria nos dois sentidos: apertada no celular,
   exagerada no desktop.

   MEDIR, NÃO CALCULAR — foi o erro da primeira versão.
   Eu deduzia a caixa a partir da maior largura entre valor, ícone e rótulo, e
   posicionava por `left`. Só que o valor é `position: absolute` e fica
   centralizado sobre o checkpoint, transbordando dos dois lados: a caixa real
   não começa onde eu supunha. A folga pedida de 6px virava 1px na tela — passou
   por acaso, e um rótulo mais longo teria sobreposto de novo.

   Agora leio as posições reais dos três elementos, calculo o recuo necessário e
   aplico só um deslocamento (`--tp-rewards-ajuste`) que se soma à âncora do
   CSS. Nada de reimplementar o alinhamento do flexbox por conta própria.
   ========================================================================= */

(function () {
  if (window.__tpRewardsFit) return;
  window.__tpRewardsFit = true;

  var FOLGA = 8; // px de respiro entre duas caixas vizinhas
  var RESPIRO_BORDA = 2; // px que a caixa mais à direita deixa antes do fim

  // Caixa visual do checkpoint: a união do valor, do ícone e do rótulo.
  // Coordenadas de viewport, que é o que basta para comparar vizinhos.
  function medir(cp) {
    /* `__dots` é o par de bolinhas do modo marcos. Sem ele na lista, `medir`
       pegava só a PRIMEIRA bolinha (querySelector) e o par media metade da
       largura real — a segunda bolinha podia vazar do trilho sem o recuo
       perceber. */
    var alvos = [
      cp.querySelector('.tp-rewards__value'),
      cp.querySelector('.tp-rewards__dots'),
      cp.querySelector('.tp-rewards__icon'),
      cp.querySelector('.tp-rewards__label')
    ];
    var esq = Infinity;
    var dir = -Infinity;
    for (var i = 0; i < alvos.length; i++) {
      if (!alvos[i]) continue;
      var r = alvos[i].getBoundingClientRect();
      if (r.left < esq) esq = r.left;
      if (r.right > dir) dir = r.right;
    }
    return { esq: esq, dir: dir };
  }

  function ajustar(trilho) {
    var cps = [].slice.call(trilho.querySelectorAll('.tp-rewards__checkpoint'));
    if (cps.length < 2) return; // uma bolinha só nunca colide

    var caixaTrilho = trilho.getBoundingClientRect();
    // Gaveta fechada ou ainda sem layout: medir agora daria tudo zero. O
    // ResizeObserver chama de novo quando ela abrir e ganhar tamanho.
    if (!caixaTrilho.width) return;

    // Zera antes de medir, senão o ajuste da passada anterior entra na conta e
    // as bolinhas iriam recuando um pouco a cada redesenho.
    var i;
    for (i = 0; i < cps.length; i++) cps[i].style.setProperty('--tp-rewards-ajuste', '0px');

    var caixas = [];
    for (i = 0; i < cps.length; i++) caixas.push(medir(cps[i]));

    var ajustes = [];
    for (i = 0; i < cps.length; i++) ajustes.push(0);

    /* 1) Ninguém passa da borda direita do trilho.

       É isto que puxa a última bolinha para trás: ela fica centralizada sobre o
       próprio texto, e recua até o texto caber. Como a bolinha para antes do
       fim, a barra CONTINUA depois dela — que é o efeito pedido. */
    var limiteTrilhoDir = caixaTrilho.right - RESPIRO_BORDA;
    for (i = 0; i < cps.length; i++) {
      if (caixas[i].dir > limiteTrilhoDir) ajustes[i] = limiteTrilhoDir - caixas[i].dir;
    }

    // 2) Da direita para a esquerda, cada vizinha recua o quanto faltar. Usar a
    // posição JÁ ajustada da vizinha da direita é o que faz o recuo se propagar
    // quando há três ou mais.
    for (i = cps.length - 2; i >= 0; i--) {
      var limiteDir = caixas[i + 1].esq + ajustes[i + 1] - FOLGA;
      if (caixas[i].dir + ajustes[i] > limiteDir) ajustes[i] = limiteDir - caixas[i].dir;
    }

    // 3) E ninguém escapa pela esquerda.
    for (i = 0; i < cps.length; i++) {
      if (caixas[i].esq + ajustes[i] < caixaTrilho.left) {
        ajustes[i] = caixaTrilho.left - caixas[i].esq;
      }
    }

    for (i = 0; i < cps.length; i++) {
      cps[i].style.setProperty('--tp-rewards-ajuste', Math.round(ajustes[i]) + 'px');
    }
  }

  function ajustarTodas() {
    var trilhos = document.querySelectorAll('.tp-rewards__checkpoints');
    for (var i = 0; i < trilhos.length; i++) ajustar(trilhos[i]);
  }

  var agendado = null;
  function agendar() {
    clearTimeout(agendado);
    agendado = setTimeout(ajustarTodas, 40);
  }

  function observar() {
    ajustarTodas();

    /* A gaveta é redesenhada a cada mudança do carrinho, e os checkpoints são
       elementos novos, sem os ajustes. */
    var raiz = document.getElementById('CartDrawer');
    if (raiz && window.MutationObserver) {
      new MutationObserver(agendar).observe(raiz, { childList: true, subtree: true });
    }

    /* ResizeObserver resolve dois casos de uma vez: girar o celular e a gaveta
       ABRIR — fechada ela não tem largura, e medir ali daria zero. */
    if (window.ResizeObserver && raiz) {
      new ResizeObserver(agendar).observe(raiz);
    } else {
      window.addEventListener('resize', agendar);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observar);
  else observar();
})();
